import { ReportQueryParamsTransform } from '@app/core/reports/components/ReportView';
import { useStationsWithAudit } from '@app/modules/audit/hooks/useStationsWithAudit';
import { Station } from '@mi-front/core';
import { GIP_QUERY_PARAM_SEPARATOR } from '../../../helpers';
import { GipReportType } from '../types';

export function useGipQueryParamsTransform(): ReportQueryParamsTransform<GipReportType> {
  const stations = useStationsWithAudit();

  const gipQueryParamTransform = {
    parse: (value: string) =>
      value
        .split(GIP_QUERY_PARAM_SEPARATOR)
        .filter((v) => !!v)
        .map((name) => ({ name })),
    serialize: (values: { name: string }[]) =>
      values.map(({ name }) => name).join(GIP_QUERY_PARAM_SEPARATOR),
  };

  const arrayQueryParamTransform = {
    parse: (value: string) =>
      value
        .split(',')
        .map((v) => v.trim())
        .filter((v) => !!v),
    serialize: (values: string[]) => values.join(','),
  };

  const customIdsQueryParamTransform = {
    parse: (value: string) => value.split(',').map((v) => ({ customId: v })),
    serialize: (values: { customId: string }[]) => values.map(({ customId }) => customId).join(','),
  };

  return {
    stations: {
      parse: (val) => {
        const selected = val
          .split(',')
          .map((s) => {
            return stations.find((station) => station.id === s || station.slug === s);
          })
          .filter((value): value is Station => !!value);

        if (selected.length === stations.length) {
          return [];
        }

        return selected;
      },
      serialize: (values: Station[]) => values.map(({ id }) => id).join(','),
    },
    advertisers: gipQueryParamTransform,
    campaigns: gipQueryParamTransform,
    versions: gipQueryParamTransform,
    customFieldKey: {
      parse: (name) => ({ name }),
    },
    orders: arrayQueryParamTransform,
    customIds: customIdsQueryParamTransform,
    excludedMatches: arrayQueryParamTransform,
  };
}
